import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Drawer, IconButton, styled } from "@mui/material";
import Proxy from "./Proxy";
import ProxyDataGrid from "./ProxyDataGrid";
const StyledDiv = styled("div")({
    display: "flex",
    flexDirection: "row",
    padding: "16px 16px 0px 0px",
    width: "100%",
    justifyContent: "space-between",
});

const StyledDrawer = styled(Drawer)(() => ({
    "& .MuiDrawer-paper": {
        padding: "0 20px",
        display: "block",
        transition: "transform 225ms cubic-bezier(0, 0, 0.2, 1)",
        maxWidth: "26rem",
        left: "auto",
        overflowX: "hidden",
        right: 0,
    },
}));

const ProxyDrawer = (props) => {
    const {
        userAccount,
        errors,
        handleDeleteArrayElement,
        handleSearchUsers,
        toggleAddProxy,
        open,
        handleDeleteProxy,
        handleAddProxy,
    } = props;

    return (
        <StyledDrawer anchor="right" open={open}>
            <div data-testid="proxy-drawer-container">
                <StyledDiv>
                    <h3>Proxies</h3>
                    <IconButton onClick={toggleAddProxy}>
                        <KeyboardArrowRightIcon />
                    </IconButton>
                </StyledDiv>
                <StyledDiv>
                    <Proxy
                        errors={errors}
                        onSearch={(term) => handleSearchUsers(term)}
                        onDelete={(index) => handleDeleteArrayElement("userAccount.allowedProxies", index)}
                        onAdd={(proxy) => handleAddProxy(proxy)}
                        userAccount={userAccount}
                        {...props}
                    />
                </StyledDiv>
                <ProxyDataGrid
                    userAccount={userAccount}
                    handleDeleteProxy={handleDeleteProxy}
                    userAllowedProxies={userAccount?.allowedProxies}
                />
            </div>
        </StyledDrawer>
    );
};

export default ProxyDrawer;
